import { useState, useEffect, useRef } from 'react';

const Description = ({
  editable,
  isRotated,
  width,
  height,
  upload,
  onClick,
}) => {
  const [description, setDescription] = useState(upload.description);
  const [state, setState] = useState('INIT');
  const handleUpdate = ({ target }) => {
    setDescription(target.value);
  };

  const inputRef = useRef(null);

  useEffect(() => {
    setDescription(upload.description || ''); // si null ne change pas description ????
    inputRef.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upload.id]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      setState('PENDING');
      upload.description = description;
      upload
        .save()
        .then(() => {
          setState('OK');
          setTimeout(() => setState(''), 1000);
        })
        .catch(() => setState('FAIL'));
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description, upload.id]); // upload.id ici et upload dans useEffect. C'est correct mais eslint rouspète

  const style = useDescriptionPosition({ isRotated, width, height });
  if (!editable) {
    return upload.description ? (
      <div
        style={style}
        className={`absolute z-9 bg-black/50 text-white`}
        onClick={onClick}
      >
        {upload.description}
      </div>
    ) : null;
  }
  let borderClass = 'border-b-2 border-info';
  switch (state) {
    case 'PENDING':
      borderClass = 'border-b-2 border-warning';
      break;
    case 'OK':
      borderClass = 'border-b-2  border-success';
      break;
    case 'FAIL':
      borderClass = 'border-b-2 border-error';
      break;
  }
  return (
    <input
      ref={inputRef}
      placeholder='Description'
      style={style}
      className={`absolute z-9 bg-black text-white text-xl ${borderClass} `}
      value={description}
      onKeyDown={({ keyCode }) => keyCode === 13 && 'Do something'}
      onClick={(e) => e.stopPropagation()}
      onChange={handleUpdate}
    />
  );
};

const computeSize = (width) => {
  if (width < 200) return 12;
  if (width < 600) return ((width - 200) / 400) * 20 + 12;
  return 32;
};

const useDescriptionPosition = ({ isRotated, width, height }) => {
  const realWidth = isRotated ? height : width;
  return {
    bottom: 0,
    left: 0,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    fontSize: computeSize(realWidth),
    width: realWidth,
  };
};

export default Description;
